export default __webpack_public_path__ + "static/media/BACKPAIN.182917e4.png";